/* eslint-disable no-unused-vars */
import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';

import { getMovimento, GetProcesso, isValid } from 'src/services/auth';
import CustomInput, { SelectInput, SearchInput } from '../../customInput';

import { ReactComponent as Check } from 'src/assets/icons/check.svg';
import { ReactComponent as End } from 'src/assets/icons/end.svg';

import showToast from 'src/components/toastyService';

import { LogContext } from 'src/components/LogProvider';

import { LoadGif } from 'src/components/LoadGif';

export default function Consulta({
  onClose,
  setTableData,
  setTableColumns,
  lastSearch,
  setLastSearch,
  porta,
  tabIndex,
  forced,
}) {
  const { setLogData, setLoadIndex } = useContext(LogContext);
  const defaultValue = new Date().toISOString().split('T')[0];
  const [inicio, setInicio] = useState();
  const [fim, setFim] = useState();

  useEffect(() => {
    setInicio(defaultValue);
    setFim(defaultValue);

    if (isValid(lastSearch?.inicio)) setInicio(lastSearch?.inicio);

    if (isValid(lastSearch?.fim)) setFim(lastSearch?.fim);

    if (forced) {
      HandleConsulta();
    }
  }, []);

  useEffect(() => {
    if (forced && inicio && fim) {
      HandleConsulta();
    }
  }, [forced, inicio, fim]);

  const [load, setLoad] = useState(false);

  const formatData = (data) => {
    const [dataAno, dataMes, dataDia] = data.split('-');
    return `${dataDia}/${dataMes}/${dataAno}`;
  };

  function HandleConsulta() {
    if (inicio != null && fim != null) {
      setLoad(true);
      const formatInicio = formatData(inicio);
      const formatFim = formatData(fim);

      setLastSearch({ inicio: inicio, fim: fim });

      const idEmp = localStorage.getItem('idEmp');
      const idFil = localStorage.getItem('idFil');

      const data = {
        codemp: idEmp,
        codfil: idFil,
        datini: formatInicio,
        datfim: formatFim,
        tipAca: 'C',
      };

      if (isValid(porta) || forced) {
        GetProcesso(porta, data, true, true)
          .then((res) => {
            let colunas = {};
            try {
              colunas = JSON.parse(res.nomeColunas);
            } catch (e) {
              colunas = {};
            }
            const dados = Array.isArray(res?.dadosGerais)
              ? res?.dadosGerais
              : [];

            setTableColumns(colunas);
            setTableData(dados);

            setLoad(false);
            setTimeout(() => {
              onClose();
            }, 10);
          })
          .catch((error) => {
            showToast('error', error);
          });
      } else {
        setLoad(false);
        showToast('error', 'Porta inválida');
      }
    }
  }

  useEffect(() => {
    setLoadIndex((prev) => ({
      ...prev,
      [tabIndex]: load,
    }));
  }, [load]);

  return (
    <div className="popup small absoluteCenter">
      {load && !forced && <LoadGif />}
      <div className={`wrap ${forced && 'forced'}`}>
        {/*
          <div className={`loading ${load ? 'show' : 'hide'}`}>
            <img src={Load} />
          </div>
        */}

        <span className="popupTitle title">
          <h2>
            Consulta <hr />
          </h2>
        </span>
        <div className="content">
          <div className="column">
            <CustomInput
              Type={'date'}
              PlaceHolder={'Inicio'}
              Color={'#0fa697'}
              OnChange={(e) => {
                setInicio(e.target.value);
              }}
              Size={'wFull'}
              DefaultValue={inicio}
            />
            <CustomInput
              Type={'date'}
              PlaceHolder={'Fim'}
              Color={'#0fa697'}
              OnChange={(e) => {
                setFim(e.target.value);
              }}
              Size={'wFull'}
              DefaultValue={fim}
            />

            <span className="consultaControls">
              <button className="mainButton red" onClick={() => onClose()}>
                <End />
                Cancelar
              </button>
              <button
                className="mainButton turquoise"
                onClick={() => HandleConsulta()}
              >
                <Check />
                Consultar
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

Consulta.propTypes = {
  onClose: PropTypes.func.isRequired,
  setTableData: PropTypes.func.isRequired,
  setTableColumns: PropTypes.func.isRequired,
  lastSearch: PropTypes.object,
  setLastSearch: PropTypes.func,
  porta: PropTypes.string,
  tabIndex: PropTypes.number,
  forced: PropTypes.bool,
};
